import { getDateDifference, isDirectBillClient, isPartPaid } from "utils/utils";
import { alertTypes, legendTypes } from "./constants";

const addAlert = (counsellor, alertType) => {
    const isInArray = counsellor.alerts.find(alert => alertType === alert)
    !isInArray && counsellor.alerts.push(alertType)
}

const setDirectAlerts = (client, counsellor) => {
    const {usedSessions, approvedSessions, expiryDate, dateOfApprovalCheck} = client

    const unUsedSessions = approvedSessions - usedSessions
    const dateDiff = expiryDate ? getDateDifference(expiryDate) : undefined 

    if (unUsedSessions === 2 || (dateDiff <= 14 && dateDiff > 7)) {
        client.alert = alertTypes.grey
        client.priority = 4
    } 
    
    if (unUsedSessions === 1 || (dateDiff <= 7 && dateDiff > 0)) {
        client.alert = alertTypes.yellow
        client.priority = 3
    } 
    
    if (unUsedSessions <= 0 || dateDiff < 1) {
        client.alert = alertTypes.red
        client.priority = 1
        addAlert(counsellor, dateOfApprovalCheck ? legendTypes.submited : legendTypes.noApproval)
    }

    if (client.alert && dateOfApprovalCheck) {
        client.alert = alertTypes.pink
        client.priority = 2
    }

    if (!client.priority) {
        client.priority = 5
    }
    
}

export const adminCounsellors = (counsellorsList) => {
    const updatedcounsellorsList = []

    counsellorsList.forEach(counsellor => {
        const updatedCounsellor = adminCounsellor(counsellor)
        
        updatedcounsellorsList.push(updatedCounsellor)
    });
    
    return updatedcounsellorsList
}

export const adminCounsellor = (counsellor) => {
    const {name, clients} = counsellor

    const updatedCounsellor = {
        name,
        alerts: [],
        id: clients[0].counsellor.acuityID,
        clients: {
            direct : {
                activeICBC: [],
                deactivatedICBC: [],
                activeOther: [],
                deactivatedOther: [],
            },
            nonDirect: {
                active: [],
                deactivated: []
            }
        }
    }

    clients.forEach(client => {
        const {paymentSource, isActive, appointments, usedSessions, chargedSessions,  mutationRequest, approvedSessions} = client
        
        if (mutationRequest) {
            client.alert = alertTypes.blue
            addAlert(updatedCounsellor, legendTypes.request) 
        }
        
        if (isDirectBillClient(paymentSource)) {
            setDirectAlerts(client, updatedCounsellor)

            if (paymentSource.toLowerCase() === "icbc") {
                if (isActive) {
                    updatedCounsellor.clients.direct.activeICBC.push({...client})
                } else {
                    updatedCounsellor.clients.direct.deactivatedICBC.push({...client})
                }
            } else {
                if (isActive) {
                    updatedCounsellor.clients.direct.activeOther.push({...client})
                } else {
                    updatedCounsellor.clients.direct.deactivatedOther.push({...client})
                }
            } 
        } else {
            client.partialPaid = 0

            appointments.forEach(appointment => {
                if(isPartPaid(appointment)) {
                    client.partialPaid += 1 
                }
            })
            
            if (client.partialPaid) {
                addAlert(updatedCounsellor, legendTypes.partialCharge)
            }

            if (usedSessions > chargedSessions && isActive) {
                client.priority = 1
                client.alert = alertTypes.red
                addAlert(updatedCounsellor, legendTypes.noPayment) 
            }

            if (!client.priority) {
                client.priority = 2
            }

            if (isActive) {
                updatedCounsellor.clients.nonDirect.active.push({...client})
            } else {
                updatedCounsellor.clients.nonDirect.deactivated.push({...client})
            }
        }
    })

    return updatedCounsellor
}